import { render, staticRenderFns } from "./EventStatsPage.vue?vue&type=template&id=66eac827"
import script from "./EventStatsPage.vue?vue&type=script&lang=js"
export * from "./EventStatsPage.vue?vue&type=script&lang=js"
import style0 from "./EventStatsPage.vue?vue&type=style&index=0&id=66eac827&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports